export enum StatsOptionPolicyEnum {
    QUANTITATIVE = 'QUANTITATIVE', // Display stats as 'highest measure' / 'lowest measure', default
    LOWEST_IS_BETTER = 'LOWEST_IS_BETTER', // Display stats as 'best measure' / 'worst measure'
    HIGHER_IS_BETTER = 'HIGHER_IS_BETTER' // Not used, this is just to remember such StatsOptions should be an enum
}

export const STATS_OPTION: { [key: string]: StatsOption } = {
    aqi: {
        min: 0,
        max: 100,
        stats: StatsOptionPolicyEnum.LOWEST_IS_BETTER
    },
    PM1_0: {
        min: 0,
        suggestedMax: 50,
        stats: StatsOptionPolicyEnum.LOWEST_IS_BETTER
    },
    PM10: {
        min: 0,
        suggestedMax: 50,
        stats: StatsOptionPolicyEnum.LOWEST_IS_BETTER
    },
    TVOC: {
        min: 0,
        suggestedMax: 100,
        stats: StatsOptionPolicyEnum.LOWEST_IS_BETTER
    },
    PM2_5: {
        min: 0,
        suggestedMax: 50,
        stats: StatsOptionPolicyEnum.LOWEST_IS_BETTER
    },
    CO2: {
        min: 0,
        suggestedMax: 1000,
        stats: StatsOptionPolicyEnum.LOWEST_IS_BETTER
    },
    pressure: {
        // auto min/max
        stats: StatsOptionPolicyEnum.QUANTITATIVE
    },
    humidity: {
        min: 0,
        max: 100,
        stats: StatsOptionPolicyEnum.QUANTITATIVE
    },
    lux: {
        min: 0,
        // auto max
        stats: StatsOptionPolicyEnum.QUANTITATIVE
    },
    dB_average: {
        suggestedMin: 30,
        suggestedMax: 50,
        stats: StatsOptionPolicyEnum.LOWEST_IS_BETTER
    },
    temperature: {
        suggestedMin: 0,
        //auto max
        stats: StatsOptionPolicyEnum.QUANTITATIVE
    }
};

export interface StatsOption {
    min?: number;
    max?: number;
    suggestedMax?: number;
    suggestedMin?: number;
    stats: StatsOptionPolicyEnum;
}